export const SONGS = [
  {
    id: 0,
    title: "Bottas",
    album: "Sr. Santos",
    artist: "Arcángel",
    cover: "https://i.scdn.co/image/ab67616d00001e0230326b23e30ae93d4d48165b",
  },
  {
    id: 1,
    title: "7 rings",
    album: "thank u, next",
    artist: "Ariana Grande",
    cover: "https://i.scdn.co/image/ab67616d00001e0256ac7b86e090f307e218e9c8",
  },
  {
    id: 2,
    title: "Duki: Bzrp Music Sessions, Vol. 50",
    album: "Duki: Bzrp Music Sessions, Vol. 50",
    artist: "Bizarrap",
    cover: "https://i.scdn.co/image/ab67616d00001e0293c4eec56cea95c9022ed28f",
  },
  {
    id: 3,
    title: "La Noche",
    album: "Hecho En MedellÃ\xadn",
    artist: "Blessd",
    cover: "https://i.scdn.co/image/ab67616d00001e020a0ee97e8ba4373476538f19",
  },
  {
    id: 4,
    title: "Triste",
    album: "La Oscuridad",
    artist: "Bryant Myers",
    cover: "https://i.scdn.co/image/ab67616d00001e02b4f4347f63b7c7835d99e85d",
  },
  {
    id: 5,
    title: "Ciudad Gris",
    album: "C.R.O - Rock",
    artist: "C.R.O",
    cover: "https://i.scdn.co/image/ab67616d00001e02ee2df133409d1e2cf0c07c19",
  },
  {
    id: 6,
    title: "Reina",
    album: "Reina",
    artist: "C.R.O",
    cover: "https://i.scdn.co/image/ab67616d00001e02988d7225497e432a82d908a5",
  },
  {
    id: 7,
    title: "Khabib",
    album: "23",
    artist: "Central Cee",
    cover: "https://i.scdn.co/image/ab67616d00001e02e1f05c994777b79bc5c87547",
  },
  {
    id: 8,
    title: "aPoLLo13",
    album: "aPoLLo13",
    artist: "Duki",
    cover: "https://i.scdn.co/image/ab67616d00001e026ec15769b079e2848fe92302",
  },
  {
    id: 9,
    title: "GIVENCHY",
    album: "GIVENCHY",
    artist: "Duki",
    cover: "https://i.scdn.co/image/ab67616d00001e02b661d9d73921e40ae97cb5e4",
  },
  {
    id: 10,
    title: "Malbec",
    album: "Desde el Fin del Mundo",
    artist: "Duki",
    cover: "https://i.scdn.co/image/ab67616d00001e02305240b65c28020de3aac8eb",
  },
  {
    id: 11,
    title: "Mbappe",
    album: "SEN2 KBRN VOL. 2",
    artist: "Eladio Carrion",
    cover: "https://i.scdn.co/image/ab67616d00001e02dce7a3fb14f5e841c0befbbf",
  },
  {
    id: 12,
    title: "Him & I (with Halsey)",
    album: "The Beautiful & Damned",
    artist: "G-Eazy",
    cover: "https://i.scdn.co/image/ab67616d00001e02046527a9c176f7c2916f3530",
  },
  {
    id: 13,
    title: "Demons",
    album: "Night Visions",
    artist: "Imagine Dragons",
    cover: "https://i.scdn.co/image/ab67616d00001e02407bd04707c463bbb3410737",
  },
  {
    id: 14,
    title: "All of Me",
    album: "Love In The Future (Expanded Edition)",
    artist: "John Legend",
    cover: "https://i.scdn.co/image/ab67616d00001e0294c9217a398f5174757c0c78",
  },
  {
    id: 15,
    title: "Isis",
    album: "Isis",
    artist: "Joyner Lucas",
    cover: "https://i.scdn.co/image/ab67616d00001e0219cd25731b71500a8bbecb13",
  },
  {
    id: 16,
    title: "Wishing Well",
    album: "Legends Never Die",
    artist: "Juice WRLD",
    cover: "https://i.scdn.co/image/ab67616d00001e023e0698e4ae5ffb82a005aeeb",
  },
  {
    id: 17,
    title: "N95",
    album: "Mr. Morale & The Big Steppers",
    artist: "Kendrick Lamar",
    cover: "https://i.scdn.co/image/ab67616d00001e022e02117d76426a08ac7c174f",
  },
  {
    id: 18,
    title: "A tus Pies",
    album: "MAWZ",
    artist: "LIT killah",
    cover: "https://i.scdn.co/image/ab67616d00001e02017f7f0b78acc1b124f4cb80",
  },
  {
    id: 19,
    title: "Homicide (feat. Eminem)",
    album: "Confessions of a Dangerous Mind",
    artist: "Logic",
    cover: "https://i.scdn.co/image/ab67616d00001e0241c0ad3e39388ab332ffb023",
  },
  {
    id: 20,
    title: "París",
    album: "SI AYER FUERA HOY",
    artist: "Morat",
    cover: "https://i.scdn.co/image/ab67616d00001e02191ce33e09ff4dd11b17d421",
  },
  {
    id: 21,
    title: "When I Grow Up",
    album: "The Search",
    artist: "NF",
    cover: "https://i.scdn.co/image/ab67616d00001e02942a0c9ac8f1def7c8805044",
  },
  {
    id: 22,
    title: "good 4 u",
    album: "SOUR",
    artist: "Olivia Rodrigo",
    cover: "https://i.scdn.co/image/ab67616d00001e02a91c10fe9472d9bd89802e5a",
  },
  {
    id: 23,
    title: "Forever Alone",
    album: "Homerun",
    artist: "Paulo Londra",
    cover: "https://i.scdn.co/image/ab67616d00001e02cf7e54f668d6a31dd6566f24",
  },
  {
    id: 24,
    title: "Party en el Barrio (feat. Duki)",
    album: "Party en el Barrio (feat. Duki)",
    artist: "Paulo Londra",
    cover: "https://i.scdn.co/image/ab67616d00001e02f310ddfa5c06fc5fddf1b1b6",
  },
  {
    id: 25,
    title: "RAPSTAR",
    album: "RAPSTAR",
    artist: "Polo G",
    cover: "https://i.scdn.co/image/ab67616d00001e02175715816616d0fb317fabeb",
  },
  {
    id: 26,
    title: "A Mí",
    album: "A Mí",
    artist: "Rels B",
    cover: "https://i.scdn.co/image/ab67616d00001e02e75742385df2e0a026001e0d",
  },
  {
    id: 27,
    title: "lo que hay x aquí",
    album: "lo que hay x aquí",
    artist: "Rels B",
    cover: "https://i.scdn.co/image/ab67616d00001e0285acf6becb994eb3cf3edd15",
  },
  {
    id: 28,
    title: "Si Te Lastimé",
    album: "Si Te Lastimé",
    artist: "Seven Kayne",
    cover: "https://i.scdn.co/image/ab67616d00001e026d44c8b65f87c623fc6aedc8",
  },
  {
    id: 29,
    title: "The Devil in I",
    album: ".5: The Gray Chapter (Special Edition)",
    artist: "Slipknot",
    cover: "https://i.scdn.co/image/ab67616d00001e02eed722040c6810f7a7da93ea",
  },
  {
    id: 30,
    title: "Something Just Like This",
    album: "Memories...Do Not Open",
    artist: "The Chainsmokers",
    cover: "https://i.scdn.co/image/ab67616d00001e020c13d3d5a503c84fcc60ae94",
  },
  {
    id: 31,
    title: "Atrevido",
    album: "Atrevido",
    artist: "Trueno",
    cover: "https://i.scdn.co/image/ab67616d00001e02f4483d4440a89a2cab3b5141",
  },
  {
    id: 32,
    title: "Estetograma",
    album: "Estetograma",
    artist: "Alcolirykoz",
    cover: "https://i.scdn.co/image/ab67616d00001e02e97b43e10295b5c31200e74e",
  },
  {
    id: 33,
    title: "Do I Wanna Know?",
    album: "AM",
    artist: "Arctic Monkeys",
    cover: "https://i.scdn.co/image/ab67616d00001e024ae1c4c5c45aabe565499163",
  },
  {
    id: 34,
    title: "Me Fui de Vacaciones",
    album: "Un Verano Sin Ti",
    artist: "Bad Bunny",
    cover: "https://i.scdn.co/image/ab67616d00001e0249d694203245f241a1bcaa72",
  },
  {
    id: 35,
    title: "Cariñito",
    album: "Listos para Bailar",
    artist: "Rodolfo Aicardi",
    cover: "https://i.scdn.co/image/ab67616d00001e0286bb6eefd9332110e1672675",
  },
  {
    id: 36,
    title: "Clocks",
    album: "A Rush of Blood to the Head",
    artist: "Coldplay",
    cover: "https://i.scdn.co/image/ab67616d00001e02de09e02aa7febf30b7c02d82",
  },
  {
    id: 37,
    title: "Conteo Regresivo - Salsa Version",
    album: "Contraste",
    artist: "Gilberto Santa Rosa",
    cover: "https://i.scdn.co/image/ab67616d00001e0207031a0d94b5340aeb77e824",
  },
  {
    id: 38,
    title: "The Wonder Years",
    album: "The Wonder Years",
    artist: "Crudo Means Raw",
    cover: "https://i.scdn.co/image/ab67616d00001e0225521504118b84259803c190",
  },
  {
    id: 39,
    title: "Estación los Alpes",
    album: "Euphanasia",
    artist: "Buhodermia å¤œ",
    cover: "https://i.scdn.co/image/ab67616d00001e026039f760b8a75736ed395d96",
  },
  {
    id: 40,
    title: "Mi Historia Entre Tus Dedos",
    album: "The Platinum Collection",
    artist: "Gianluca Grignani",
    cover: "https://i.scdn.co/image/ab67616d00001e02295a625768d54448a78d4d68",
  },
  {
    id: 41,
    title: "Just the Two of Us",
    album: "Winelight",
    artist: "Grover Washington",
    cover: "https://i.scdn.co/image/ab67616d00001e02d8e0e065037b496212e554b7",
  },
  {
    id: 42,
    title: "I Wanna Be Yours",
    album: "AM",
    artist: "Arctic Monkeys",
    cover: "https://i.scdn.co/image/ab67616d00001e024ae1c4c5c45aabe565499163",
  },
  {
    id: 43,
    title: "La flaca",
    album: "La Flaca - EdiciÃ³n 10Âº Aniversario",
    artist: "Jarabe De Palo",
    cover: "https://i.scdn.co/image/ab67616d00001e02aef5ce2f4997ed15ebbc2977",
  },
  {
    id: 44,
    title: "Patatús",
    album: "Hockey",
    artist: "Lasser",
    cover: "https://i.scdn.co/image/ab67616d00001e024255084428fc9d3bc49029a0",
  },
  {
    id: 45,
    title: "Lost on You",
    album: "Lost on You",
    artist: "LP",
    cover: "https://i.scdn.co/image/ab67616d00001e02edd52840c88ba5e7163071cf",
  },
  {
    id: 46,
    title: "Weekend (feat. Miguel)",
    album: "GO:OD AM",
    artist: "Mac Miller",
    cover: "https://i.scdn.co/image/ab67616d00001e02ee0f38410382a255e4fb15f4",
  },
  {
    id: 47,
    title: "By My Own",
    album: "By My Own",
    artist: "Robot95",
    cover: "https://i.scdn.co/image/ab67616d00001e02de87535fb5c31ae35be74ce6",
  },
  {
    id: 48,
    title: "Summer",
    album: "Motion",
    artist: "Calvin Harris",
    cover: "https://i.scdn.co/image/ab67616d00001e02063c048e9ef6bd021b744756",
  },
  {
    id: 49,
    title: "Rain",
    album: "Rain",
    artist: "Trueno",
    cover: "https://i.scdn.co/image/ab67616d00001e02bf55119e1968bfecc2f2309e",
  },
  {
    id: 50,
    title: "Intocable - Remix",
    album: "Intocable (Remix)",
    artist: "Vgomez",
    cover: "https://i.scdn.co/image/ab67616d00001e028397e8512db9f63ce809a5f7",
  },
  {
    id: 51,
    title: "Virtual Diva",
    album: "iDon",
    artist: "Don Omar",
    cover: "https://i.scdn.co/image/ab67616d00001e0295129e69ff6fa71a6c2c5adf",
  },
];

export const PLAYLIST_URL =
  "https://open.spotify.com/playlist/6vxH4MUd1sa6Hkh8LCx0ic?si=aa74de8514164d4d";
